(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lumari-hair-quiz-dv"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.lq-wrap').forEach(initLumariQuiz);
});

function initLumariQuiz(root) {
  var steps = Array.prototype.slice.call(root.querySelectorAll('.lq-step'));
  var questionSteps = steps.filter(function (s) { return s.hasAttribute('data-question'); });
  var progressFill = root.querySelector('[data-lq-progress-fill]');
  var backBtn = root.querySelector('[data-lq-back]');
  var current = 0;
  var history = [0];

  function showStep(index) {
    steps.forEach(function (s, i) {
      s.classList.toggle('is-active', i === index);
    });
    var step = steps[index];
    var isQuestion = step.hasAttribute('data-question');
    var pct = (index / (steps.length - 1)) * 100;
    progressFill.style.width = pct + '%';
    backBtn.hidden = history.length <= 1 || !isQuestion;

    // every answered question moves her forward, so log the partial answers on each new question
    if (index > 0 && !quizDone && (step.hasAttribute('data-question') || step.classList.contains('lq-loading'))) {
      sendToSheet(false);
    }
    if (step.classList.contains('lq-loading')) {
      runLoadingSequence(step);
    }
    if (step.getAttribute('data-step') === '12') {
      renderGauge();
      renderSummary();
      quizDone = true;
      sendToSheet(false);
    }
  }

  function goTo(index) {
    current = index;
    history.push(index);
    showStep(current);
  }

  function goNext() {
    if (current < steps.length - 1) {
      goTo(current + 1);
    }
  }

  function goBack() {
    if (history.length > 1) {
      history.pop();
      current = history[history.length - 1];
      showStep(current);
    }
  }

  function syncOptionVisual(input) {
    var option = input.closest('.lq-option');
    if (option) {
      option.classList.toggle('is-checked', input.checked);
    }
  }

  // single-select: auto-advance
  root.querySelectorAll('input[type="radio"]').forEach(function (input) {
    input.addEventListener('change', function () {
      var group = input.name;
      root.querySelectorAll('input[name="' + group + '"]').forEach(syncOptionVisual);
      setTimeout(goNext, 250);
    });
  });

  // multi-select: toggle visual + enable continue button per step
  root.querySelectorAll('.lq-step[data-multi]').forEach(function (step) {
    var checkboxes = Array.prototype.slice.call(step.querySelectorAll('input[type="checkbox"]'));
    var continueBtn = step.querySelector('[data-lq-multi-continue]');
    checkboxes.forEach(function (box) {
      box.addEventListener('change', function () {
        syncOptionVisual(box);
        var anyChecked = checkboxes.some(function (b) { return b.checked; });
        if (continueBtn) {
          if (anyChecked) {
            continueBtn.removeAttribute('disabled');
          } else {
            continueBtn.setAttribute('disabled', 'disabled');
          }
        }
      });
    });
    if (continueBtn) {
      continueBtn.addEventListener('click', function () {
        if (!continueBtn.hasAttribute('disabled')) {
          goNext();
        }
      });
    }
  });

  root.querySelectorAll('[data-lq-continue]').forEach(function (btn) {
    btn.addEventListener('click', goNext);
  });

  root.querySelectorAll('[data-lq-skip]').forEach(function (btn) {
    btn.addEventListener('click', goNext);
  });

  backBtn.addEventListener('click', goBack);

  function getCheckedValues(selector) {
    return Array.prototype.slice.call(root.querySelectorAll(selector + ':checked'));
  }

  function getChecked(selector) {
    return root.querySelector(selector + ':checked');
  }

  function runLoadingSequence(step) {
    var items = Array.prototype.slice.call(step.querySelectorAll('[data-checklist-item]'));
    var i = 0;
    items.forEach(function (item) { item.classList.remove('is-active', 'is-done'); });
    items[0].classList.add('is-active');
    var interval = setInterval(function () {
      items[i].classList.remove('is-active');
      items[i].classList.add('is-done');
      i++;
      if (i >= items.length) {
        clearInterval(interval);
        setTimeout(goNext, 400);
        return;
      }
      items[i].classList.add('is-active');
    }, 850);
  }

  var hoogResult = {
    condition: 'Overactive', potential: 'High', confidence: 'Noticeable', timeline: '4 weeks'
  };

  function renderGauge() {
    var cfg = hoogResult;
    var conditionEl = root.querySelector('[data-stat-condition]');
    var potentialEl = root.querySelector('[data-stat-potential]');
    var confidenceEl = root.querySelector('[data-stat-confidence]');
    var timelineEl = root.querySelector('[data-stat-timeline]');

    if (conditionEl) conditionEl.textContent = cfg.condition;
    if (potentialEl) potentialEl.textContent = cfg.potential;
    if (timelineEl) timelineEl.textContent = cfg.timeline;
    if (confidenceEl) confidenceEl.textContent = cfg.confidence;
  }

  // personal summary from her own answers; always lands on "high", grammar follows how many she picked
  var AGE_TEXT = { '18-29': 'In your twenties', '30-39': 'In your thirties', '40-49': 'In your forties', '50+': 'After 50' };
  var ZONE_TEXT = {
    'Chin and jawline': 'chin', 'Upper lip': 'upper lip', 'Sideburns / sides of face': 'sideburns',
    'Neck': 'neck', 'Bikini line': 'bikini line', 'Underarms': 'underarms'
  };
  var METHOD_TEXT = {
    'Plucking / tweezers': 'tweezers', 'Shaving': 'a razor', 'Threading': 'threading', 'Waxing': 'wax',
    'Laser or IPL': 'laser', 'Electrolysis': 'electrolysis', 'Hair removal cream': 'hair removal cream'
  };
  var SPEED_TEXT = {
    'Within a few hours': 'within hours', 'After 1–2 days': 'in a day or two', 'After 3 days or longer': 'within a few days'
  };
  var STRUGGLE_TEXT = {
    'The hair grows back too fast': 'how fast it grows back', 'The dark marks it leaves behind': 'the dark marks it leaves',
    'Bumps and ingrown hairs': 'the ingrown bumps', "Laser didn't work on my skin": "laser that didn't work on your skin",
    'Pain and irritation': 'the pain and irritation', 'It makes me feel self-conscious': 'how self-conscious it makes you feel'
  };
  var REACTION_TEXT = {
    'Dark marks': 'dark marks', 'Bumps': 'bumps', 'Ingrown hairs': 'ingrown hairs', 'Razor burn': 'razor burn',
    'Irritation / sensitivity': 'irritation', 'Itching / dryness': 'itching'
  };
  var DEEPER_SKIN = ['Black / African American', 'Afro-Caribbean / African', 'Latina / Hispanic', 'South Asian', 'Arab / Middle Eastern / North African', 'Mixed'];

  function picked(name, map, max) {
    var out = [];
    root.querySelectorAll('input[name^="lq-' + name + '-"]:checked').forEach(function (b) {
      var txt = map[b.value];
      if (txt && out.indexOf(txt) === -1) out.push(txt);
    });
    return out.slice(0, max);
  }

  function joinList(items) {
    if (items.length <= 1) return items.join('');
    return items.slice(0, -1).join(', ') + ' and ' + items[items.length - 1];
  }

  function renderSummary() {
    var el = root.querySelector('[data-lq-summary]');
    if (!el) return;
    var age = (root.querySelector('input[name^="lq-age-"]:checked') || {}).value;
    var speed = (root.querySelector('input[name^="lq-speed-"]:checked') || {}).value;
    var ethnicity = (root.querySelector('input[name^="lq-ethnicity-"]:checked') || {}).value;
    var texture = (root.querySelector('input[name^="lq-texture-"]:checked') || {}).value;
    var zones = picked('zone', ZONE_TEXT, 2);
    var methods = picked('method', METHOD_TEXT, 2);
    var struggles = picked('struggle', STRUGGLE_TEXT, 2);
    var reactions = picked('reaction', REACTION_TEXT, 2);

    var where = zones.length ? 'your ' + joinList(zones) : 'your face';
    var s1 = (AGE_TEXT[age] ? AGE_TEXT[age] + ', you' : 'You') +
      (methods.length ? ' use ' + joinList(methods) + ' on ' + where : ' remove the hair on ' + where) +
      (SPEED_TEXT[speed] ? ", and it's back " + SPEED_TEXT[speed] + '.' : '.');

    var s2 = '';
    if (struggles.length === 1) s2 = ' Your biggest frustration is ' + struggles[0] + '.';
    if (struggles.length > 1) s2 = ' Your biggest frustrations are ' + joinList(struggles) + '.';

    // skip reactions she already named as a frustration
    var said = struggles.join(' ');
    reactions = reactions.filter(function (r) { return said.indexOf(r) === -1; });
    var s3 = '';
    if (reactions.length) {
      s3 = ' Your skin answers every removal with ' + joinList(reactions);
      if (reactions.indexOf('dark marks') !== -1 && DEEPER_SKIN.indexOf(ethnicity) !== -1) {
        s3 += (reactions.length === 1 ? ', which' : ', and the marks') + ' tend to linger on deeper skin';
      }
      s3 += '.';
    }
    if (texture === 'Coarse and curly' && said.indexOf('ingrown') === -1) s3 += ' And coarse, curly hair can grow right back into the skin.';

    el.innerHTML = s1 + s2 + s3 + ' <strong>That keeps your follicle activity high, so removing it better won&rsquo;t fix it. Slowing it down will.</strong>';
  }

  // answers -> Google Sheet (Apps Script web app); one row per visit, updated when she clicks the CTA
  var sheetUrl = root.getAttribute('data-sheet-url');
  var quizDone = false;
  var sessionId = Date.now().toString(36) + Math.random().toString(36).slice(2, 8);

  function answersFor(name) {
    var boxes = root.querySelectorAll('input[name^="lq-' + name + '-"]:checked');
    return Array.prototype.map.call(boxes, function (b) { return b.value; }).join(', ');
  }

  function sendToSheet(clickedCta) {
    if (!sheetUrl) return;
    var params = new URLSearchParams(window.location.search);
    var payload = JSON.stringify({
      session_id: sessionId,
      quiz: 'quiz-dv',
      age: answersFor('age'),
      zones: answersFor('zone'),
      methods: answersFor('method'),
      speed: answersFor('speed'),
      struggles: answersFor('struggle'),
      ethnicity: answersFor('ethnicity'),
      skin: answersFor('skin'),
      reactions: answersFor('reaction'),
      texture: answersFor('texture'),
      completed: quizDone,
      cta: clickedCta,
      utm_source: params.get('utm_source') || '',
      utm_medium: params.get('utm_medium') || '',
      utm_campaign: params.get('utm_campaign') || '',
      utm_content: params.get('utm_content') || '',
      page_url: window.location.href,
      device: /Mobi|Android|iPhone/i.test(navigator.userAgent) ? 'mobile' : 'desktop'
    });
    // sendBeacon survives the page navigating away after the CTA click
    if (navigator.sendBeacon && navigator.sendBeacon(sheetUrl, new Blob([payload], { type: 'text/plain' }))) return;
    fetch(sheetUrl, { method: 'POST', mode: 'no-cors', body: payload, keepalive: true });
  }

  var ctaBtn = root.querySelector('[data-lq-cta]');
  if (ctaBtn) {
    ctaBtn.addEventListener('click', function () { sendToSheet(true); });
  }

  showStep(0);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lumari-hair-quiz"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.lq-wrap').forEach(initLumariQuiz);
});

function initLumariQuiz(root) {
  var steps = Array.prototype.slice.call(root.querySelectorAll('.lq-step'));
  var questionSteps = steps.filter(function (s) { return s.hasAttribute('data-question'); });
  var progressFill = root.querySelector('[data-lq-progress-fill]');
  var backBtn = root.querySelector('[data-lq-back]');
  var current = 0;
  var history = [0];

  function showStep(index) {
    steps.forEach(function (s, i) {
      s.classList.toggle('is-active', i === index);
    });
    var step = steps[index];
    var isQuestion = step.hasAttribute('data-question');
    var pct = (index / (steps.length - 1)) * 100;
    progressFill.style.width = pct + '%';
    backBtn.hidden = history.length <= 1 || !isQuestion;

    if (step.classList.contains('lq-loading')) {
      runLoadingSequence(step);
    }
    if (step.getAttribute('data-step') === '12') {
      renderGauge();
    }
  }

  function goTo(index) {
    current = index;
    history.push(index);
    showStep(current);
  }

  function goNext() {
    if (current < steps.length - 1) {
      goTo(current + 1);
    }
  }

  function goBack() {
    if (history.length > 1) {
      history.pop();
      current = history[history.length - 1];
      showStep(current);
    }
  }

  function syncOptionVisual(input) {
    var option = input.closest('.lq-option');
    if (option) {
      option.classList.toggle('is-checked', input.checked);
    }
  }

  // single-select: auto-advance
  root.querySelectorAll('input[type="radio"]').forEach(function (input) {
    input.addEventListener('change', function () {
      var group = input.name;
      root.querySelectorAll('input[name="' + group + '"]').forEach(syncOptionVisual);
      setTimeout(goNext, 250);
    });
  });

  // multi-select: toggle visual + enable continue button per step
  root.querySelectorAll('.lq-step[data-multi]').forEach(function (step) {
    var checkboxes = Array.prototype.slice.call(step.querySelectorAll('input[type="checkbox"]'));
    var continueBtn = step.querySelector('[data-lq-multi-continue]');
    checkboxes.forEach(function (box) {
      box.addEventListener('change', function () {
        syncOptionVisual(box);
        var anyChecked = checkboxes.some(function (b) { return b.checked; });
        if (continueBtn) {
          if (anyChecked) {
            continueBtn.removeAttribute('disabled');
          } else {
            continueBtn.setAttribute('disabled', 'disabled');
          }
        }
      });
    });
    if (continueBtn) {
      continueBtn.addEventListener('click', function () {
        if (!continueBtn.hasAttribute('disabled')) {
          goNext();
        }
      });
    }
  });

  root.querySelectorAll('[data-lq-continue]').forEach(function (btn) {
    btn.addEventListener('click', goNext);
  });

  root.querySelectorAll('[data-lq-skip]').forEach(function (btn) {
    btn.addEventListener('click', goNext);
  });

  backBtn.addEventListener('click', goBack);

  function getCheckedValues(selector) {
    return Array.prototype.slice.call(root.querySelectorAll(selector + ':checked'));
  }

  function getChecked(selector) {
    return root.querySelector(selector + ':checked');
  }

  function runLoadingSequence(step) {
    var items = Array.prototype.slice.call(step.querySelectorAll('[data-checklist-item]'));
    var i = 0;
    items.forEach(function (item) { item.classList.remove('is-active', 'is-done'); });
    items[0].classList.add('is-active');
    var interval = setInterval(function () {
      items[i].classList.remove('is-active');
      items[i].classList.add('is-done');
      i++;
      if (i >= items.length) {
        clearInterval(interval);
        setTimeout(goNext, 400);
        return;
      }
      items[i].classList.add('is-active');
    }, 850);
  }

  var hoogResult = {
    condition: 'Overactive', potential: 'High', confidence: 'Noticeable', timeline: '4 weeks'
  };

  function renderGauge() {
    var cfg = hoogResult;
    var conditionEl = root.querySelector('[data-stat-condition]');
    var potentialEl = root.querySelector('[data-stat-potential]');
    var confidenceEl = root.querySelector('[data-stat-confidence]');
    var timelineEl = root.querySelector('[data-stat-timeline]');

    if (conditionEl) conditionEl.textContent = cfg.condition;
    if (potentialEl) potentialEl.textContent = cfg.potential;
    if (timelineEl) timelineEl.textContent = cfg.timeline;
    if (confidenceEl) confidenceEl.textContent = cfg.confidence;
  }

  showStep(0);
}

  } catch(e) { console.error(e); }
})();
})();
